import { __rest } from "tslib";
import * as React from 'react';
const SendFill = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M13.942 20.5a.67.67 0 01-.63-.441l-2.628-7.243-7.243-2.628a.67.67 0 010-1.259L19.6 3.04a.67.67 0 01.858.859l-5.888 16.16a.669.669 0 01-.63.44v.001z" })));
};
SendFill.displayName = 'SendFill';
export default SendFill;
//# sourceMappingURL=SendFill.js.map